import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { eps } from './url.service'
import { Country } from '../store/country/country.state'

export interface PlansAnalytics {
  totalPlans: number
  activePlans: number
  inactivePlans: number
  noOfPlanTypes: number
}

export interface Plan {
  name: string
  type: 'monthly' | 'yearly'
  position: number
  minimumLicences: number
  price: number
  currencyId: string
  planCurrency?: Country
  discountType?: 'fixed' | 'percentage' | null
  discountValue: number
  availableFeatures?: string[]
  trialDays: number
  isRecommended: boolean
  isActive: boolean
  description?: string | null
}

export interface PlanResponse extends Plan {
  id: string
  totalSubscribers: number
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date
}

export interface PlansListResponse {
  plans: PlanResponse[]
  takenPositions: { monthly: number[]; yearly: number[] }
  totalCount: number
}

@Injectable({
  providedIn: 'root'
})
export class PlansService {
  api = eps.superAdmin.plansApi
  http = inject(HttpClient)
  getPlans(filters: {
    type?: string | null
    status?: string | null
    search?: string | null
    page?: number
    limit?: number
  }) {
    let params = new HttpParams()
    if (filters.page) params = params.set('page', filters.page.toString())
    if (filters.limit) params = params.set('limit', filters.limit.toString())
    if (filters.type) params = params.set('type', filters.type)
    if (filters.status) params = params.set('status', filters.status)
    if (filters.search) params = params.set('search', filters.search)
    return this.http.get<PlansListResponse>(this.api, { params })
  }

  getRegisterPlans(filters: {
    type?: string | null
    status?: string | null
    search?: string | null
    page?: number
    limit?: number
  }) {
    let params = new HttpParams()
    if (filters.page) params = params.set('page', filters.page.toString())
    if (filters.limit) params = params.set('limit', filters.limit.toString())
    if (filters.type) params = params.set('type', filters.type)
    if (filters.status) params = params.set('status', filters.status)
    if (filters.search) params = params.set('search', filters.search)
    return this.http.get<PlansListResponse>(`${this.api}/registerPlans`, { params })
  }

  addPlan(plan: Plan) {
    return this.http.post<PlanResponse>(this.api, plan)
  }

  editPlan(id: string, plan: Plan) {
    return this.http.put<PlanResponse>(this.api + `/${id}`, plan)
  }

  deletePlan(planId: string) {
    return this.http.delete<PlanResponse>(this.api + '/' + planId)
  }

  getAnalytics() {
    return this.http.get<PlansAnalytics>(this.api + '/analytics')
  }
}
